// extracted by mini-css-extract-plugin
export default {"helperText":"HelperText_helperText__5CZQM font-xs-regular"};